/**
 * Фирменная обложка новости без картинки — вместо серой заглушки на главной (владелец, 02.11.2026).
 * Рисуется, когда у новости нет ни обложки, ни картинки во вложениях (правило API: обложка →
 * первая картинка → null). Navy и бронза бренда, мягкие круги и знак AS; оттенок и положение кругов
 * берутся из id новости, так что соседние плитки разные, а одна и та же новость всегда одинаковая.
 * Тема не влияет: обложка тёмная сама по себе, как фото.
 */
import { Image } from 'react-native'
import Svg, { Circle, Defs, LinearGradient, Rect, Stop } from 'react-native-svg'
import { Stack } from 'tamagui'

const mark = require('../../../assets/brand/as-mark-gold.png')

const BRONZE = '#D8BE88'
// от navy бренда (CHROME.navy) к четырём оттенкам
const PALETTES = [
  ['#13245A', '#2B4C9B'], // синий
  ['#101F4C', '#1E5D6E'], // морская волна
  ['#16265C', '#4A3B7A'], // индиго
  ['#13245A', '#6E5A2E'], // бронза
] as const

/** FNV-1a: стабильное число из id — одна новость всегда с той же обложкой. */
const hash = (s: string) => {
  let h = 2166136261
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i)
    h = Math.imul(h, 16777619)
  }
  return h >>> 0
}

export function NewsCover({ seed }: { seed: string }) {
  const h = hash(seed)
  const [from, to] = PALETTES[h % PALETTES.length]
  // id градиента уникален на обложку: в вебе одинаковые id соседних SVG подменяют друг другу заливку
  const id = `asl-news-${h.toString(36)}`
  // доля 0…1 из разных битов хэша — положение кругов (viewBox 440×200)
  const f = (k: number) => ((h >>> (k * 5)) & 31) / 31
  return (
    <Stack position="absolute" top={0} left={0} right={0} bottom={0} overflow="hidden" aria-hidden>
      <Svg width="100%" height="100%" viewBox="0 0 440 200" preserveAspectRatio="xMidYMid slice">
        <Defs>
          <LinearGradient id={id} x1="0" y1="0" x2="1" y2="1">
            <Stop offset="0" stopColor={from} />
            <Stop offset="1" stopColor={to} />
          </LinearGradient>
        </Defs>
        <Rect x="0" y="0" width="440" height="200" fill={`url(#${id})`} />
        <Circle cx={300 + f(0) * 120} cy={-20 + f(1) * 80} r={110} fill="#FFFFFF" fillOpacity={0.06} />
        <Circle cx={40 + f(2) * 140} cy={170 + f(3) * 40} r={90} fill={BRONZE} fillOpacity={0.1} />
        <Circle cx={190 + f(4) * 90} cy={96} r={46} fill="none" stroke={BRONZE} strokeOpacity={0.35} strokeWidth={1.5} />
      </Svg>
      <Image source={mark} style={{ position: 'absolute', right: 16, bottom: 14, width: 34, height: 34, opacity: 0.9 }} resizeMode="contain" />
    </Stack>
  )
}
